import { CreatUpdateLead, WSCallDetailsData } from "./../../model/creat-update-lead";
import { QdeService } from "./../../services/qde.service";
import { SharedServiceService } from "./../../services/shared-service.service";
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewEncapsulation, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { IwService } from "../../services/iw.service";
import { MatDialog } from "@angular/material/dialog";
import { OtpModelBoxComponent } from "../otp-model-box/otp-model-box.component";
import { Router } from "@angular/router";
import { GENERIC_ERRORS, GENERIC_ERROR, VALIDATION_MSG, ISTATACARD, IS_CAMPAIGN, TOOLTIPS, base_https_url, RETRIEVE_APPLICATION_URL_DECRYPT, BRAND_APPROVED_ERRORS, TRACK_APP, DECRYPT_VALIDATE_REFERRAL } from "src/app/config/app-settings.config";
import { OtpStatusValues, scrollTopChange, getCookie } from "src/app/utilities/utilities.file";
import { RetrievePopUpComponent } from '../retrieve-pop-up/retrieve-pop-up.component';
import { LoaderService } from 'src/app/services/loader.service';
import { EncrDecrService } from 'src/app/services/encr-decr-service.service';
import { CatalogueService } from 'src/app/services/catalogue.service'
import { ValidateReferralService } from 'src/app/services/validate-referral.service';
import { ThemeService } from 'src/app/services/theme.service';
declare var $: any;
declare var AmoScript: Function;
declare var _satellite: any;
declare var form_next_click: Function;
declare var analytics: any;
@Component({
  selector: "app-about-yourself",
  templateUrl: "./about-yourself.component.html",
  styleUrls: ["./about-yourself.component.scss"],
  encapsulation: ViewEncapsulation.None,

})
export class AboutYourselfComponent implements OnInit, AfterViewInit {
  aboutYourselfForm: FormGroup;
  cityList: any;
  aboutRequest = new CreatUpdateLead();
  wsDetails = new WSCallDetailsData();
  salutations: any;
  eapplyFormLabel: any;
  _cardCategory: any;
  _cardtype: any;
  OtpStatusValues = OtpStatusValues;
  otpStatus: OtpStatusValues = OtpStatusValues.OTP_NOT_GENERATED;
  aboutMessages = GENERIC_ERRORS;
  leadGenerated: boolean;
  otpSuccess: boolean = false;
  @ViewChild("matPersonalBlock") personalBlock: ElementRef;
  city = "";
  state = "";
  @Input() existingUser: FormControl;
  @Input() cardDcrData: any;
  @Input() masterData: any;
  enableNextbutton = false;
  enableSendOtp = true;
  firstSectionCompleted = false;
  filterCity: any;
  enableMobileField = false;
  @Output() personalSectionCompleted = new EventEmitter<any>();
  @Output() retriveData = new EventEmitter<any>();
  @Output() resetFlagUpdate = new EventEmitter<any>();
  errorMessage: any;
  first_name: any;
  middle_name: any;
  last_name: any;
  holder: boolean = false;
  nextLine: boolean = false;
  genricError: any;
  dcrData: any;
  btnDisabled: boolean = true;
  cityDisabled = false;
  newJourneyCounter = 0;
  newJourneyCounterValidate = 0;
  TATACARD = ISTATACARD;
  cardholderImage: any
  isBanca: any;
  placeholder: boolean = false;
  firstNameTooltip: boolean = false;
  lastNameCheck: boolean;
  checkFirstName: boolean = false;
  requiredField: boolean = false;
  shortLeadData: string;
  validationMsgs: any;
  tooltips: any;
  errorMessage1: any;
  dynamicCardUrl: any;
  altDynamicCardUrl: any;
  bancaPromoConfig: any;
  isShortLeadRetrive: any;
  @Input() banca1Form: FormGroup;
  isShortLeadNew: string;
  referralCodeValue: any;
  referralValue: string;
  validateRefObj: {
    referralCode: any;
  };
  showValidGreenTick: boolean;
  invalidMessage: boolean = false;
  validMessage: boolean = false;
  invalidRefferalCodeServiceFailure: boolean = false;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  shortcampaign: any;
  shortLink: any;
  fromSwiftJourney: boolean;

  constructor(
    private fb: FormBuilder,
    private qdeService: QdeService,
    private iwService: IwService,
    public dialog: MatDialog,
    private sharedData: SharedServiceService,
    private iw: IwService,
    private router: Router,
    private loaderService: LoaderService,
    private encryptDecService: EncrDecrService,
    private validateService: ValidateReferralService,
    private catalogueService: CatalogueService,
    private themeService: ThemeService
  ) {
    this.partnerCode = this.themeService.partnerCode;
    // document.cookie="e-apply-data=abad,,gauri,8005665572,t@t.com,AGRA,1";
    // document.cookie="isShortLeadNew=true";
  }

  ngOnInit() {
    this.fromSwiftJourney = this.sharedData.fromSwiftJourney;
    this.shortcampaign = this.sharedData.sslEnabled;
    console.log('this.shortcampaign value' + this.shortcampaign);
    this.containerType = sessionStorage.getItem('container-type');
    this.genricError = GENERIC_ERRORS;
    this.validationMsgs = VALIDATION_MSG;
    this.tooltips = TOOLTIPS;
    this.createForm();
    this.f.fcnCity.valueChanges.subscribe(value => {
      if (value && value.length >= 2 && this.cityList) {
        this.filterCity = this.cityList.filter(city =>
          city.name.toLowerCase().startsWith(value.toLowerCase())
        );
        // this.filterCity = this.cityList.filter(city =>
        //   city.name.toLowerCase().includes(value.toLowerCase())
        // );
        if (value) {
          let found: any;
          found = this.cityList.find(f => value == f.name);
          found ? this.aboutYourselfForm.get('fcnCity').setErrors(null) : this.aboutYourselfForm.get('fcnCity').setErrors({ 'cityNotFound': true });
        }
      } else {
        this.filterCity = [];
      }
    });
    this.salutations = this.iwService.getsalutationDropdown().dcrContent.root.name_value_pair;
    this.eapplyFormLabel = this.iwService.geteapplyFormLabelDcr().dcrContent.root;
    this.bancaPromoConfig = this.iw.getBancaDefaultConfigurationDCR();
    this.isBanca = this.sharedData.paramschannel && this.sharedData.paramschannel == '901' ? true : false;
    this.cardholderImage = this.TATACARD ? '/tata-card-en/resources/img/eapply/cardName.svg' : '/sbi-card-en/resources/img/eapply/cardName.svg';
    this.shortLeadData = getCookie('e-apply-data');
    this.referralValue = sessionStorage.getItem('referralCode');
    if (this.shortLeadData || this.referralValue) {
      const data = this.shortLeadData.split(',');
      this.aboutYourselfForm.patchValue({
        fcnFirstName: data && data[0],
        fcnMiddleName: data && data[1],
        fcnLastName: data && data[2],
        fcnMobile: data && data[3],
        fcnEmail: data && data[4],
        fcnCity: data && data[5],
        fcnSalutation: data && +data[6],
        fcnReferralCode: this.referralValue,
      });
      this.sharedData.setName(data && data[0]);
      this.enableOtpButton();
    }

    this.patchDetailsForRetrieve();
    if (this.sharedData.paramsshortCode || (this.sharedData.paramsmobileNo && this.sharedData.paramsfirstName)) {
      this.enableMobileField = true;
      this.enableSendOtp = false;
      this.enableNextbutton = true;
    }

    this.isShortLeadRetrive = getCookie('isShortLeadRetrive');
    this.isShortLeadNew = getCookie('isShortLeadNew');
    if (this.isShortLeadRetrive === 'true' || this.isShortLeadNew === 'true') {
      this.enableSendOtp = false;
      this.enableNextbutton = true;
      this.enableMobileField = true;
    }
    this.displayUser();
    this.f.fcnFirstName.valueChanges.subscribe(value => {
      this.sharedData.setName(value);
      value ? this.hideLable1() : true;
      this.displayUser();
    });
    this.f.fcnCity.valueChanges.subscribe(value => {
      value ? this.hideLable() : true;
    });
    if (this.sharedData.cardName) {
      window["digitalData"].card = { cardName: this.sharedData.cardName };
    }
    if (this.isShortLeadNew === 'true') {
      this.createUpdateReq();
      //this.secondStep=true;
    }
  }



  //Validate service starts
  public validateFun() {
    this.validateRefObj = {
      "referralCode": this.f.fcnReferralCode.value
    }
    //console.log("this.f.fcnReferralCode.value=", this.f.fcnReferralCode.value);
    this.validateService.validateReferralCode(this.validateRefObj).subscribe((result: any) => {
      result = DECRYPT_VALIDATE_REFERRAL ? this.encryptDecService.get(result) : result;
      if (result) {
        if (result && result.ValidateReferralResponse && result.ValidateReferralResponse.referralCode) {
          this.validMessage = true;
          this.showValidGreenTick = true;
          this.invalidMessage = false;
          this.invalidRefferalCodeServiceFailure = false;
        } else if (result && result.validateReferralDetailsResponse && result.validateReferralDetailsResponse.errorCode) {
          this.showValidGreenTick = false;
          this.invalidMessage = true;
          this.invalidRefferalCodeServiceFailure = false;
        } else {
          this.showValidGreenTick = false;
          this.invalidMessage = false;
          this.invalidRefferalCodeServiceFailure = false;
        }
      } else {
        //this.errorMessage = "Empty";
        this.showValidGreenTick = false;
        this.invalidMessage = false;
        this.invalidRefferalCodeServiceFailure = true;
      }
    },
      (error) => {
        this.showValidGreenTick = false;
        this.invalidMessage = false;
        this.invalidRefferalCodeServiceFailure = true;
      }
    );
  };

  //service call is On blur
  validateServiceCall() {
    const referralRegex = /^[a-zA-Z0-9]+$/
    if (this.f.fcnReferralCode.value.length >= 10 && this.f.fcnReferralCode.value.length <= 13 && referralRegex.test(this.f.fcnReferralCode.value)) {
      //console.log("Valid Referral Code");
      this.invalidMessage = false;
      this.invalidRefferalCodeServiceFailure = false;
      this.validateRefObj = {
        "referralCode": this.f.fcnReferralCode.value
      }
      //console.log("this.f.fcnReferralCode.value=", this.f.fcnReferralCode.value);
      this.validateService.validateReferralCode(this.validateRefObj).subscribe((result: any) => {
        result = DECRYPT_VALIDATE_REFERRAL ? this.encryptDecService.get(result) : result;
        //console.log("Decrypt ==>", result);
        if (result) {
          if (result && result.ValidateReferralResponse && result.ValidateReferralResponse.referralCode) {
            this.validMessage = true;
            this.showValidGreenTick = true;
            this.invalidMessage = false;
            this.invalidRefferalCodeServiceFailure = false;
          } else if (result && result.validateReferralDetailsResponse && result.validateReferralDetailsResponse.errorCode) {
            this.invalidRefferalCodeServiceFailure = false;
            this.showValidGreenTick = false;
            this.invalidMessage = true;
            // this.invalidRefferalCodeServiceFailure = false;
          } else {
            this.showValidGreenTick = false;
            this.invalidMessage = false;
            this.invalidRefferalCodeServiceFailure = false;
          }
        } else {
          //this.errorMessage = "Empty";
          this.showValidGreenTick = false;
          this.invalidMessage = false;
          this.invalidRefferalCodeServiceFailure = true;
        }
      },
        (error) => {
          this.showValidGreenTick = false;
          this.invalidMessage = false;
          this.invalidRefferalCodeServiceFailure = true;
        }
      );
    }
    else {
      //console.log("Invalid Referral Code");
      this.invalidMessage = true;
      this.invalidRefferalCodeServiceFailure = false;
    }
  }
  //validate service ends

  ngAfterViewInit() {

    let isShortLeadNew = getCookie('isShortLeadNew');
    console.log(this.isShortLeadRetrive);
    console.log(isShortLeadNew);
    if (this.isShortLeadRetrive === 'true' || isShortLeadNew === 'true') {
      this.f.fcnConsent.setValue(true);
    } else {
      this.f.fcnConsent.setValue(false);
    }
    if (this.referralValue) {
      //console.log("Session Storage Referral Code Value");
      const referralRegex = /^[a-zA-Z0-9]+$/
      if (this.referralValue.length >= 10 && this.referralValue.length <= 13 && referralRegex.test(this.referralValue)) {
        //console.log("Valid sessionReferral Code");
        this.invalidMessage = false;
        this.invalidRefferalCodeServiceFailure = false;
        this.validateFun();
      } else {
        //console.log("Invalid session Referral Code");
        this.invalidMessage = true;
        this.invalidRefferalCodeServiceFailure = false;
      }
    };
  }

  ngOnChanges() {
    const xml = this.cardDcrData;
    if (xml) {
      this._cardtype = xml.root.card_information.card_type;
      this.sharedData.sbic_card_Type = this._cardtype;
      this._cardCategory = xml.root.card_information.card_category
      if (xml && xml.root && xml.root['eapply-benefits1'] && xml.root['eapply-benefits1'].eapply_cardFaces && xml.root['eapply-benefits1'].eapply_cardFaces.image_url) {
        this.dynamicCardUrl = base_https_url + xml.root['eapply-benefits1'].eapply_cardFaces.image_url;
      }

      if (xml && xml.root && xml.root['eapply-benefits1'] && xml.root['eapply-benefits1'].eapply_cardFaces && xml.root['eapply-benefits1'].eapply_cardFaces.image_alt_text) {
        this.altDynamicCardUrl = base_https_url + xml.root['eapply-benefits1'].eapply_cardFaces.image_alt_text;
      }
    }
    if (this.masterData) {
      console.log("master data", this.masterData);
      this.cityDisabled = false;
      console.log("city Disbaled 5", this.cityDisabled);
      if (this.sharedData.paramschannel && this.sharedData.paramschannel == '901') {
        this.cityList = this.masterData.bancaCityList;
      } else {
        this.cityList = this.masterData.cityList;
      }
    }
    else {
      this.cityDisabled = true;
      console.log("city Disbaled 6", this.cityDisabled);
    }
  }

  createForm() {
    this.aboutYourselfForm = this.fb.group({
      fcnSalutation: ["", Validators.required],
      fcnFirstName: ["", [Validators.required, Validators.pattern("^[A-Za-z]+$")]],
      fcnMiddleName: ["", Validators.pattern("^[A-Za-z]+$")],
      fcnLastName: ["", [Validators.required, Validators.pattern("^[A-Za-z]+$")]],
      fcnCity: ["", Validators.required],
      fcnEmail: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:!#{}'?/|`~$%^&*+=\s@"]+(\.[^<>()\[\]\\.,;:!#{}'?/|`~$%^&*+=\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ]
      ],
      fcnMobile: ["", [Validators.required, Validators.pattern("^([3-9]{1}[0-9]{9})$")]],
      fcnConsent: ["", Validators.required],
      fcnReferralCode: [""]
    });
  }

  get f() {
    return this.aboutYourselfForm.controls;
  }

  get bf() {
    return this.banca1Form.controls;
  }

  sendOtp() {
    // this.onSubmit()
    if (IS_CAMPAIGN) {
      window["page"] = 'ev_send_otp';
      window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
      AmoScript();
    }
    if (window['_satellite']) {
      _satellite.track("send_otp")
    }

    if (this.f.fcnMobile.invalid) {
      this.f.fcnMobile.markAsTouched();
      return;
    } else {
      this.enableSendOtp = false;
      let reasonCode: any;
      if (this.sharedData.paramsshortCode) {
        reasonCode = '121';
      } else {
        reasonCode = '101';

      }
      this.qdeService
        .generateOtp('000' + this.f.fcnMobile.value + '999999', this.f.fcnMobile.value, "false", reasonCode)
        .subscribe(
          (result: any) => {
            if (
              result.OTPGenerationRsType.statusDesc.toLowerCase() === "success" &&
              result.OTPGenerationRsType.statusCode == "000"
            ) {
              this.errorMessage = '';
              this.errorMessage1 = '';
              this.otpStatus = OtpStatusValues.OTP_GENERATED;
              this.otpSuccess = true;
              this.btnDisabled = true;
              this.newJourneyCounter += 1;
              this.openDialogAndSendOtp();
            } else if (
              result.OTPGenerationRsType.statusCode !== "000"
            ) {
              this.otpStatus = OtpStatusValues.OTP_NOT_GENERATED;
              this.otpSuccess = false;
              this.errorMessage = GENERIC_ERROR;
              this.enableSendOtp = true;
            }
          }, error => {
            this.otpSuccess = false;
            this.errorMessage = GENERIC_ERROR;
            this.enableSendOtp = true;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
          }
        );
    }
    // Analytics for Send OTP
    if (window['analytics']) {
      console.log("The email id is", this.f.fcnEmail.value);
      analytics.track('eapply__click__send_otp', {
        'MODE_OF_CONVERSION': '',
        'IS_ORGANIC': 'N',
        'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
        'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
        'CHANNEL_NAME': this.sharedData.paramschannel,
        'Mobile_no': this.f.fcnMobile.value,
        'JOURNEY_NAME': 'EAPPLY',
        'ERROR_DESCRIPTION': '',
        'FIRST_NAME': this.f.fcnFirstName.value,
        'LAST_NAME': this.f.fcnLastName.value,
        'MIDDLE_NAME': this.f.fcnMiddleName.value,
        'residential_city': this.f.fcnCity.value,
        'EMAIL': this.f.fcnEmail.value,
        'REFERRAL_CODE': this.f.fcnReferralCode.value,
        'CARD_TYPE': this.cardDcrData.root.card_information.card_type
      });
    }

  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  onSubmit() {
    let labelsDisplay: any;
    if (this.eapplyFormLabel) {
      if (this.eapplyFormLabel.title_text && this.eapplyFormLabel.title_text.title_label) {
        labelsDisplay = this.eapplyFormLabel.title_text.title_label
      } if (this.eapplyFormLabel.firstName_text && this.eapplyFormLabel.firstName_text.firstName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.firstName_text.firstName_label
      } if (this.eapplyFormLabel.middleName_text && this.eapplyFormLabel.middleName_text.middleName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.middleName_text.middleName_label
      } if (this.eapplyFormLabel.lastName_text && this.eapplyFormLabel.lastName_text.lastName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.lastName_text.lastName_label
      } if (this.eapplyFormLabel.pinCode_text && this.eapplyFormLabel.pinCode_text.pinCode_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.pinCode_text.pinCode_label
      } if (this.eapplyFormLabel.email_text && this.eapplyFormLabel.email_text.email_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.email_text.email_label
      } if (this.eapplyFormLabel.referral_container && this.eapplyFormLabel.referral_container.referralcode_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.referral_container.referralcode_label
      } if (this.eapplyFormLabel.mobile_container && this.eapplyFormLabel.mobile_container.mobile_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.mobile_container.mobile_label
        labelsDisplay = labelsDisplay + "|" + "consent"
      }
      // alert(labelsDisplay)
    }
    form_next_click(this.sharedData.cardName, 'Personal Details', labelsDisplay);
    if (this.aboutYourselfForm.invalid || this.lastNameCheck) {
      Object.keys(this.f).forEach(key => {
        this.aboutYourselfForm.get(key).markAsTouched();
      });
      return;
    } else if (this.otpStatus !== OtpStatusValues.OTP_VALIDATED && this.isShortLeadRetrive === 'false') {
      this.otpStatus = OtpStatusValues.OTP_NOT_VALIDATED;
      return;
    } else {
      if (this.isShortLeadRetrive === 'true' || this.isShortLeadNew === 'true') {
        this.qdeService.signedValueResponse = sessionStorage.getItem('ds');
      }
      this.callGenerateLead();

    }


  }

  callGenerateLead() {
    // this.wsDetails.WSCallUserSalutation = this.f.fcnSalutation.value || null;
    // this.wsDetails.WSCallUserGender = this.f.fcnSalutation.value == 2 ? "F" : "M";
    // this.wsDetails.WSCallExistingCardHolder = this.existingUser.value || null;
    // this.wsDetails.WSCallUserFirstName = this.f.fcnFirstName.value && this.f.fcnFirstName.value.toUpperCase() || null;
    // this.wsDetails.WSCallUserMiddleName = this.f.fcnMiddleName.value && this.f.fcnMiddleName.value.toUpperCase() || null;
    // this.wsDetails.WSCallUserLastName = this.f.fcnLastName.value && this.f.fcnLastName.value.toUpperCase() || null;
    // this.wsDetails.WSCallUserCity = this.f.fcnCity.value || null;
    // this.wsDetails.WSCallUserEmailId = this.f.fcnEmail.value || null;
    // this.wsDetails.WSCallUserMobileNumber = this.f.fcnMobile.value || null;
    // this.wsDetails.WSCallUserContactConsent = (this.f.fcnConsent && this.f.fcnConsent.value == true) ? 'Y' : ((this.f.fcnConsent && this.f.fcnConsent.value == false) ? 'N' : '');
    // this.wsDetails.WSCallCardType = this._cardtype || null;
    // this.wsDetails.WSCallCardCategory = this._cardCategory || null;
    // let gem1 = this.sharedData.paramsgemid1? this.sharedData.paramsgemid1 : '';
    // let gem2 = this.sharedData.paramsgemid2? this.sharedData.paramsgemid2 : '';
    // this.wsDetails.WSCallGemId1 = this.sharedData.paramsshortCode ? 'C2B_' + gem1 : gem1;
    // this.wsDetails.WSCallGemId2 = this.sharedData.paramsshortCode ? 'C2B_' + gem2 : gem2;
    // this.wsDetails.WSCallDomainName = "sbicard";
    // this.wsDetails.WSCallSourceCode = IS_CAMPAIGN ? 'DC' : 'WEBS';
    // this.wsDetails.WSCallChannelCode = this.isBanca ? 'EALB' : ((this.sharedData.paramschannel && this.sharedData.paramschannel == '701') ? "EABP" : "EAPL");
    // this.wsDetails.WSCallUserSbiRelationShipNumber = this.bf.fncSBIRelationship ? this.bf.fncSBIRelationship.value : null;
    // this.wsDetails.WSCallUserHousingLoan = this.bf.fcnHouseLoan ? this.bf.fcnHouseLoan.value : null;
    // this.wsDetails.WSCallUserCarLoan = this.bf.fcnCarLoan ? this.bf.fcnCarLoan.value : null;
    // this.wsDetails.WSCallUserSavingsAccount = this.bf.fcnAccountNo ? this.bf.fcnAccountNo.value : null;
    // // addd promo code for generate lead service here
    // this.wsDetails.WSCallPromoCode = this.sharedData.promoCode
    // this.aboutRequest.wsCallDetailsData = this.wsDetails;
    // this.aboutRequest = this.trimObject(this.aboutRequest);
    this.createUpdateReq();
    console.log('qde request', this.aboutRequest);

    this.qdeService.createUpdateLead(this.aboutRequest).subscribe(
      (res: any) => {
        if (res.LeadGenerationRes.WSCallStatusCode === "000") {
          this.shortLink = res.LeadGenerationRes.WSCallShortLink;
          this.errorMessage = '';
          this.errorMessage1 = '';
          console.log(this.sharedData.sslEnabled);
          if (this.sharedData.sslEnabled == true) {
            this.router.navigate(['./success']);
          } else {
            this.callMaster();
            this.personalSectionCompleted.emit({
              completed: true,
              stepIndex: 1
            });
            this.otpStatus = OtpStatusValues.OTP_VALIDATED;
            this.qdeService.aboutData = this.wsDetails;
            console.log("WS Details 1", this.wsDetails);

            let sequenceId = res.LeadGenerationRes.WSCallSequenceId ? res.LeadGenerationRes.WSCallSequenceId : '';
            this.sharedData.amoSequeceNumber = sequenceId;

            if (IS_CAMPAIGN) {
              window["page"] = 'ev_qde_section1';
              window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
              AmoScript();
            }
          }


        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode === '112') {
          this.errorMessage = '';
          this.errorMessage1 = '';
          this.otpStatus = OtpStatusValues.OTP_VALIDATED;
          this.qdeService.aboutData = this.wsDetails;
          console.log("WS Details 2", this.wsDetails);
          this.retrievePopUp();
          this.sharedData.resetSslEnabled = false;
          this.resetFlagUpdate.emit(true);

        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode == "108" && res.LeadGenerationRes.WSCallStatusDescription) {
          this.errorMessage1 = BRAND_APPROVED_ERRORS.duplicateRecord;
          this.errorMessage = '';
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode !== "000" && res.LeadGenerationRes.WSCallStatusDescription) {
          this.errorMessage = res.LeadGenerationRes.WSCallStatusDescription;
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
          this.personalSectionCompleted.emit({
            completed: false,
            stepIndex: 0
          });
          this.qdeService.aboutData = "";
        }
      }, err => {
        this.errorMessage1 = '';
        this.errorMessage = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
      },
      () => {
        if (window['analytics']) {
          analytics.track('eapply__click__next__after_otp_verification', {
            'MODE_OF_CONVERSION': '',
            'IS_ORGANIC': 'N',
            'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
            'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
            'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
            'CHANNEL_NAME': this.sharedData.paramschannel,
            'JOURNEY_NAME': 'EAPPLY',
            'FIRST_NAME': this.f.fcnFirstName.value,
            'LAST_NAME': this.f.fcnLastName.value,
            'MIDDLE_NAME': this.f.fcnMiddleName.value,
            'EMAIL': this.wsDetails.WSCallUserEmailId,
            'MOBILE_NO': this.f.fcnMobile.value,
            'residential_city': this.f.fcnCity.value,
            'CARD_TYPE': this.cardDcrData.root.card_information.card_type,
            'REFERRAL_CODE': this.f.fcnReferralCode.value,
            'shortcode': this.shortLink
          });
        }
      }
    );
  }



  retrievePopUp() {
    const dialogRef1 = this.dialog.open(RetrievePopUpComponent, {
      disableClose: true,
      data: {
        firstName: this.f.fcnFirstName.value.trim(),
        mobileNumber: this.f.fcnMobile.value.trim()
      }
    });

    dialogRef1.afterClosed().subscribe(res => {
      if (res && res == true) {
        this.retrieveApplication();
      } else {
        this.sharedData.continueWithNewApp = true;
        this.wsDetails.WSCallUpdateIncompleteAppFlag = 'Y';
        this.aboutRequest.wsCallDetailsData = this.wsDetails;
        this.qdeService.createUpdateLead(this.aboutRequest).subscribe(
          (res: any) => {
            if (res.LeadGenerationRes.WSCallStatusCode === "000") {
              let sequenceId = res.LeadGenerationRes.WSCallSequenceId ? res.LeadGenerationRes.WSCallSequenceId : '';
              this.sharedData.amoSequeceNumber = sequenceId;
              if (IS_CAMPAIGN) {
                window["page"] = 'ev_qde_section1';
                window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
                AmoScript();
              }
              this.errorMessage = '';
              this.errorMessage1 = '';
              this.callMaster();
              this.otpStatus = OtpStatusValues.OTP_VALIDATED;
              this.qdeService.aboutData = this.wsDetails;
              this.personalSectionCompleted.emit({
                completed: true,
                stepIndex: 1
              });
            } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode == "108" && res.LeadGenerationRes.WSCallStatusDescription) {
              this.errorMessage1 = BRAND_APPROVED_ERRORS.duplicateRecord;
              window["digitalData"].error = { message: GENERIC_ERROR };
              if (window['_satellite']) {
                _satellite.track('form_error');
              }
            } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode !== "000" && res.LeadGenerationRes.WSCallStatusDescription) {
              this.errorMessage1 = '';
              window["digitalData"].error = { message: GENERIC_ERROR };
              if (window['_satellite']) {
                _satellite.track('form_error');
              }
              this.errorMessage = GENERIC_ERROR;
            }
          }, err => {
            this.errorMessage1 = '';
            this.errorMessage = GENERIC_ERROR;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
          }
        );
      }
    });
  }

  retrieveApplication() {
    console.log("retrieve service called from about-yourself");
    const requestBodyForRetrievePopUp = {
      WSCallUserMobileNumber: this.f.fcnMobile.value.trim()
    }
    if (window['_satellite']) {
      _satellite.track('retrieve_application');
    }
    this.sharedData.retriveApplication(requestBodyForRetrievePopUp).subscribe((res: any) => {
      if (res) {
        res = RETRIEVE_APPLICATION_URL_DECRYPT ? this.encryptDecService.get(res) : res;
      }
      if (res && res.RetrieveLeadErrorRsType && res.RetrieveLeadErrorRsType.status.toLowerCase() == 'failure') {
        this.sharedData.abortMessage = TRACK_APP.trackError;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
        this.router.navigate(['/track-application', 'track-error']);
      } else {
        this.sharedData.retrievedApplicationResponse = res;
        console.log("res: " + res);
        this.sharedData.paramsfirstName = res.RetrieveLeadRsType.WSCallUserFirstName;
        this.sharedData.paramsmobileNo = res.RetrieveLeadRsType.WSCallUserMobileNumber;
        this.retriveData.emit({
          data: res
        });
        // this.sharedData.retrievedApplicationResponse = res.RetrieveLeadRsType;
        let sequenceId = res.RetrieveLeadRsType.WSCallSequenceId ? res.RetrieveLeadRsType.WSCallSequenceId : '';
        this.sharedData.amoSequeceNumber = sequenceId;
        if (IS_CAMPAIGN) {
          window["page"] = 'ev_retrieve';
          window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
          AmoScript();
        }
        this.patchDetailsForRetrieve();
        if (window['analytics']) {
          console.log('The shared Data is: -', this.sharedData);
          analytics.track('eapply__page__existing_application', {
            'MODE_OF_CONVERSION': '',
            'IS_ORGANIC': 'N',
            'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
            'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
            'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
            'CHANNEL_NAME': this.sharedData.paramschannel,
            'JOURNEY_NAME': 'EAPPLY',
            'FIRST_NAME': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName,
            'LAST_NAME': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserLastName,
            'MIDDLE_NAME': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName,
            'email': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserEmailId,
            'Mobile_no': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber,
            'residential_city': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity,
            'CARD_TYPE': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardType,
            'OCCUPATION': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOccupationCode,
            'COMPANY_NAME': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCompany,
            'designation': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDesignation,
            'ANNUAL_SALARY': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserAnnualIncomeValue,
            'office_pin_code': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserOfficePincode,
            'pan': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserPanNumber,
            'DOB': this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserDOB
          });
        }

      }
    }, error => {
      this.sharedData.abortMessage = TRACK_APP.trackError;
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
      this.router.navigate(['/track-application', 'track-error']);
    })



  }

  openDialogAndSendOtp() {
    if (this.f.fcnMobile.invalid) {
      this.f.fcnMobile.markAsTouched();
      return;
    } else {
      const dialogRef = this.dialog.open(OtpModelBoxComponent, {
        disableClose: true,
        data: {
          mobileNumber: this.f.fcnMobile.value.trim(),
          newJourneyCounter: this.newJourneyCounter,
          creditCardNo: '000' + this.f.fcnMobile.value.trim() + '999999'
        },
        width: this.partnerCode && this.containerType ? '480px' : null,
        // margin-bottom :this.partnerCode && this.containerType? '220px': 'inherit',
        panelClass: this.partnerCode && this.containerType ? 'custom-modalbox' : null,
        hasBackdrop: this.partnerCode && this.containerType ? false : true,
        // position: bottom
      });

      dialogRef.afterClosed().subscribe(result => {
        if (this.partnerCode && this.containerType) {
          document.getElementById('sbicard') ? document.getElementById('sbicard').style.background = 'none' : true;
          let element: any = document.getElementsByClassName('iw_viewport-wrapper')[0];
          element.style.display = 'block';
        }
        if (result) {
          this.otpStatus = result.otpValidated;
          this.newJourneyCounter = result.counter;
          if (this.newJourneyCounter >= 5) {
            this.btnDisabled = true;
          } else {
            this.btnDisabled = false;
          }
          if (this.otpStatus == this.OtpStatusValues.OTP_NOT_VALIDATED) {
            this.enableSendOtp = true;
            this.enableNextbutton = false;
            this.enableMobileField = false;
          } else if (this.otpStatus == this.OtpStatusValues.OTP_VALIDATED) {
            Object.keys(this.f).forEach(key => {
              this.aboutYourselfForm.get(key).markAsTouched();
            });
            this.enableSendOtp = false;
            this.enableNextbutton = true;
            this.enableMobileField = true;
          }
        }
      });
    }
  }

  enableMobile() {
    this.enableMobileField = false;
    this.enableSendOtp = true;
    this.enableNextbutton = false;
  }

  displayUser() {
    let lengthOfInput: number = 0;
    this.first_name = this.f.fcnFirstName.value.trim();
    this.sharedData.applicantName = this.f.fcnFirstName.value.trim();
    lengthOfInput = lengthOfInput + this.first_name.length
    if (this.f.fcnMiddleName && this.f.fcnMiddleName.value) {
      this.middle_name = this.f.fcnMiddleName.value.trim();
      lengthOfInput = lengthOfInput + this.middle_name.length
    }
    if (this.f.fcnLastName && this.f.fcnLastName.value) {
      this.last_name = this.f.fcnLastName.value.trim();
      lengthOfInput = lengthOfInput + this.last_name.length
    }
    if (lengthOfInput >= 25) {
      this.nextLine = true;
    } else {
      this.nextLine = false;
    }
  }

  numberOnlyPhone(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  alphabetsOnly(event) {
    let regex = /[a-zA-Z]/;
    if (event.key.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  alphaNumeric(event) {
    //let regex = /[a-zA-Z0-9 ]/;
    let regex = '[A-Z0-9\\s()-.]*';
    if (event.key.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  numberOnlyPin(event) {
    if (this.f.fcnCity.value.length < 1) {
      let regex1 = /[1-9]/;
      if (event.key.match(regex1)) {
        return true;
      } else {
        return false;
      }
    } else {
      let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
  }

  enableOtpButton() {
    if (this.f.fcnMobile.value && this.f.fcnMobile.value.length < 10) {
      this.btnDisabled = true;
    } else {
      if (this.newJourneyCounter >= 5 || this.qdeService.existingJCounterValidate >= 5) {
        this.btnDisabled = true;
      } else {
        this.qdeService.counterValidate = 0;
        this.btnDisabled = false;
      }
    }
  }

  patchDetailsForRetrieve() {
    if (this.sharedData.retrievedApplicationResponse) {
      if (this.fromSwiftJourney) {
        console.log("this.sharedData.retrievedApplicationResponse from the new swift app journey" + this.sharedData.retrievedApplicationResponse);
        this.aboutYourselfForm.patchValue({
          fcnSalutation: this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.applicantDetails.salutation ? +(this.sharedData.retrievedApplicationResponse.data.applicantDetails.salutation) : null,
          fcnFirstName: this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.applicantDetails.firstName ? this.sharedData.retrievedApplicationResponse.data.applicantDetails.firstName : null,
          // fcnMiddleName: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName : null,
          fcnMiddleName : null,
          fcnLastName: this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.applicantDetails.lastName ? this.sharedData.retrievedApplicationResponse.data.applicantDetails.lastName : null,
          fcnCity: this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.contactDetails.resiCity ? this.sharedData.retrievedApplicationResponse.data.contactDetails.resiCity : null,
          fcnMobile: this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.applicantDetails.mobileNumber ? this.sharedData.retrievedApplicationResponse.data.applicantDetails.mobileNumber : null,
          fcnEmail: this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedData.retrievedApplicationResponse.data.applicantDetails.personalEmailId : null,
          // fcnReferralCode: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardReferralCode ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardReferralCode : null,
          fcnReferralCode : null,
          fcnConsent: (this.sharedData.retrievedApplicationResponse.data.consentGiven && this.sharedData.retrievedApplicationResponse.data.consentGiven == 'Y') ? true : false,
        })
        let gem1 = this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.gemId1 ? this.sharedData.retrievedApplicationResponse.data.gemId1 : '';
        let gem2 = this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.gemId2 ? this.sharedData.retrievedApplicationResponse.data.gemId2 : '';
        // let gem1 = '';
        // let gem2 = '';
        console.log("this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.gemId1: " + gem1);
        console.log("this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.gemId2: " + gem2);
        console.log("gem1:" + gem1);
        console.log("gem2:" + gem2);
        this.wsDetails.WSCallGemId1 = this.sharedData.paramsshortCode ? 'C2B_' + gem1 : gem1;
        this.wsDetails.WSCallGemId2 = this.sharedData.paramsshortCode ? 'C2B_' + gem2 : gem2;
        this.enableOtpButton();
        this.enableMobileField = true;
        this.enableSendOtp = false;
        this.enableNextbutton = true;
        this.otpStatus = OtpStatusValues.OTP_VALIDATED;
        this.wsDetails.WSCallUpdateIncompleteAppFlag = 'Y';
        this.sharedData.setName(this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.applicantDetails.firstName ? this.sharedData.retrievedApplicationResponse.data.applicantDetails.firstName : null);
      }
      else {
        console.log("this.sharedData.retrievedApplicationResponse" + this.sharedData.retrievedApplicationResponse);
        this.aboutYourselfForm.patchValue({
          fcnSalutation: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation ? +(this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserSalutation) : null,
          fcnFirstName: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName : null,
          fcnMiddleName: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMiddleName : null,
          fcnLastName: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserLastName ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserLastName : null,
          fcnCity: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity : null,
          fcnMobile: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserMobileNumber : null,
          fcnEmail: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserEmailId ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserEmailId : null,
          fcnReferralCode: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardReferralCode ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardReferralCode : null,
          fcnConsent: (this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserContactConsent && this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserContactConsent == 'Y') ? true : false,
        })
        let gem1 = this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1 ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1 : '';
        let gem2 = this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2 ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2 : '';
        console.log("this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1: " + this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1);
        console.log("this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2: " + this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2);
        console.log("gem1:" + gem1);
        console.log("gem2:" + gem2);
        this.wsDetails.WSCallGemId1 = this.sharedData.paramsshortCode ? 'C2B_' + gem1 : gem1;
        this.wsDetails.WSCallGemId2 = this.sharedData.paramsshortCode ? 'C2B_' + gem2 : gem2;
        this.enableOtpButton();
        this.enableMobileField = true;
        this.enableSendOtp = false;
        this.enableNextbutton = true;
        this.otpStatus = OtpStatusValues.OTP_VALIDATED;
        this.wsDetails.WSCallUpdateIncompleteAppFlag = 'Y';
        this.sharedData.setName(this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserFirstName : null);
      }

    }
  }

  checkWithFirstName() {
    if ((this.f.fcnFirstName.value.toUpperCase() == this.f.fcnLastName.value.toUpperCase()) && (this.f.fcnLastName.status != 'INVALID') && (this.f.fcnFirstName.status != 'INVALID')) {
      this.checkFirstName = true;
      this.lastNameCheck = true;
    }
    else {
      this.lastNameCheck = false;
      this.checkFirstName = false;
    }

  }

  showLable() {
    console.log("show label", this.f.fcnCity.disabled);
    this.f.fcnCity.value.length === 0 ? this.placeholder = true : true;
  }

  hideLable() {
    this.f.fcnCity.value.length === 0 ? this.placeholder = true : this.placeholder = false;
  }

  focusOut() {
    this.placeholder = false;
  }

  showLable1() {
    this.f.fcnFirstName.value.length === 0 ? this.firstNameTooltip = true : true;
  }

  hideLable1() {
    this.f.fcnFirstName.value.length === 0 ? this.firstNameTooltip = true : this.firstNameTooltip = false;
  }

  focusOut1() {
    this.firstNameTooltip = false;
  }
  callFormAbandon(label) {
    if (!this.sharedData.formFieldTouch) {
      this.sharedData.formFieldTouch = true;
      if (window['_satellite']) {
        _satellite.track('form_start')
      }
    }
    let abandonRequest: any;
    abandonRequest = {
      section: "About your self",
      field: label
    }
    this.sharedData.setAnalyticsFormAbandon(abandonRequest);
  }

  createUpdateReq() {
    this.wsDetails.WSCallUserSalutation = this.f.fcnSalutation.value || null;
    this.wsDetails.WSCallUserGender = this.f.fcnSalutation.value == 2 ? "F" : "M";
    this.wsDetails.WSCallExistingCardHolder = this.existingUser.value || null;
    this.wsDetails.WSCallUserFirstName = this.f.fcnFirstName.value && this.f.fcnFirstName.value.toUpperCase() || null;
    this.wsDetails.WSCallUserMiddleName = this.f.fcnMiddleName.value && this.f.fcnMiddleName.value.toUpperCase() || null;
    this.wsDetails.WSCallUserLastName = this.f.fcnLastName.value && this.f.fcnLastName.value.toUpperCase() || null;
    this.wsDetails.WSCallUserCity = this.f.fcnCity.value || null;
    this.wsDetails.WSCallUserEmailId = this.f.fcnEmail.value || null;
    this.wsDetails.WSCallUserMobileNumber = this.f.fcnMobile.value || null;
    //this.wsDetails.WSCallCardReferralCode = (this.invalidMessage || this.invalidRefferalCodeServiceFailure) ? null : this.f.fcnReferralCode.value;
    //this.wsDetails.WSCallCardReferralCode = this.invalidMessage ? null : this.f.fcnReferralCode.value;
    this.wsDetails.WSCallCardReferralCode = this.validMessage == true ? this.f.fcnReferralCode.value : null;
    this.wsDetails.WSCallUserContactConsent = (this.f.fcnConsent && this.f.fcnConsent.value == true) ? 'Y' : ((this.f.fcnConsent && this.f.fcnConsent.value == false) ? 'N' : '');
    this.wsDetails.WSCallCardType = this._cardtype || null;
    this.wsDetails.WSCallCardCategory = this._cardCategory || null;
    // let gem1 = this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.gemId1 ? this.sharedData.retrievedApplicationResponse.data.gemId1 : '';
    let gem1 = '';
    if (this.sharedData.paramsgemid1 != null || this.sharedData.paramsshortCode != null) {
      if (this.sharedData.paramsgemid1 != null) {
        gem1 = this.sharedData.paramsgemid1;
      }
      else if (this.sharedData.paramsshortCode != null) {
        if(this.fromSwiftJourney){
          // gem1 = '';
          gem1 = this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.gemId1 ? this.sharedData.retrievedApplicationResponse.data.gemId1 : '';
        }
        else{
          if ((this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1) != null) {
            gem1 = this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId1;
          }
        }
      }
    }
    //check if service has has refferal key then set gem2 to 'refer'
    let isReferEnabled = this.referralValue ? true : false;
    //let gem2 = this.sharedData.paramsgemid2? this.sharedData.paramsgemid2 : this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2 ? this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2 : isReferEnabled ? 'refer' : '';
    let gem2 = '';
    if (this.sharedData.paramsgemid2 != null || this.sharedData.paramsshortCode != null || isReferEnabled) {
      if (this.sharedData.paramsgemid2 != null) {
        gem2 = this.sharedData.paramsgemid2;
      }
      else if (this.sharedData.paramsshortCode != null) {
        if(this.fromSwiftJourney){
          gem2 = this.sharedData.retrievedApplicationResponse.data && this.sharedData.retrievedApplicationResponse.data.gemId2 ? this.sharedData.retrievedApplicationResponse.data.gemId2 : '';
        }
        else{
          if ((this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType && this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2) != null) {
            gem2 = this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2;
          }
        }
      }
      else if (isReferEnabled) {
        gem2 = 'refer';
      }
    }
    console.log("this.sharedData.paramsgemid1:" + this.sharedData.paramsgemid1);
    console.log("this.sharedData.paramsgemid2:" + this.sharedData.paramsgemid2);
    console.log("this.sharedData.paramsshortCode:" + this.sharedData.paramsshortCode);
    // console.log("this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2" +this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallGemId2);
    console.log("gem1:" + gem1);
    console.log("gem2:" + gem2);
    this.wsDetails.WSCallGemId1 = this.sharedData.paramsshortCode ? 'C2B_' + gem1 : gem1;
    this.wsDetails.WSCallGemId2 = this.sharedData.paramsshortCode ? 'C2B_' + gem2 : gem2;
    if (this.themeService.themeParam) {
      this.wsDetails.WSCallLeadOrigination = `PI_${this.themeService.themeParam}`;
    }

    if (this.shortcampaign == true) {
      this.wsDetails.WSCallLeadOrigination = `SL`;
    }
    if (isReferEnabled && this.showValidGreenTick) {
      this.wsDetails.WSCallGemId2 = 'refer';
      console.log(this.wsDetails.WSCallGemId2);
    }

    this.wsDetails.WSCallDomainName = "sbicard";
    this.wsDetails.WSCallSourceCode = IS_CAMPAIGN ? 'DC' : 'WEBS';
    this.wsDetails.WSCallChannelCode = this.isBanca ? 'EALB' : ((this.sharedData.paramschannel && this.sharedData.paramschannel == '701') ? "EABP" : this.sharedData.fromSwiftJourney ? "SAPL" : "EAPL");
    this.wsDetails.WSCallUserSbiRelationShipNumber = this.bf.fncSBIRelationship ? this.bf.fncSBIRelationship.value : null;
    this.wsDetails.WSCallUserHousingLoan = this.bf.fcnHouseLoan ? this.bf.fcnHouseLoan.value : null;
    this.wsDetails.WSCallUserCarLoan = this.bf.fcnCarLoan ? this.bf.fcnCarLoan.value : null;
    this.wsDetails.WSCallUserSavingsAccount = this.bf.fcnAccountNo ? this.bf.fcnAccountNo.value : null;
    // addd promo code for generate lead service here
    // this.wsDetails.WSCallPromoCode = this.sharedData.promoCode
    this.aboutRequest.wsCallDetailsData = this.wsDetails;
    this.aboutRequest = this.trimObject(this.aboutRequest);
    this.qdeService.aboutData = this.wsDetails;
  }
  //service call for getting the designation and company name based on parameter
  callMaster() {
    let requestBody: any;
    console.log("inside Call master method name" + this.sharedData.paramsfirstName);
    console.log("inside Call master method Number" + this.sharedData.paramsmobileNo);
    requestBody = {
      cardType: this.cardDcrData.root.card_information.card_type,
      cardChannelCode: (this.sharedData.paramschannel && this.sharedData.paramschannel == '901') ? "EALB" : ((this.sharedData.paramschannel && this.sharedData.paramschannel == '701') ? "EABP" : this.sharedData.fromSwiftJourney ? "SAPL" : "EAPL"),
      cityList: 'N',
      // companyList: "Y",
      companyList: (this.sharedData.paramsfirstName && this.sharedData.paramsmobileNo) || this.sharedData.paramsshortCode ? "N" : "Y",
      bancaCityList: 'N',
      // designationList: "Y"
      designationList: (this.sharedData.paramsfirstName && this.sharedData.paramsmobileNo) || this.sharedData.paramsshortCode ? "N" : "Y"
    };
    this.qdeService.fetchMatserData(requestBody).subscribe((result: any) => {
      if (result.eapplyMasterDataRsType && result.eapplyMasterDataRsType.statusCode === "000") {

        let company: any;
        let designation: any;
        company = result.eapplyMasterDataRsType.companyList ? result.eapplyMasterDataRsType.companyList : null;
        designation = result.eapplyMasterDataRsType.designationList ? result.eapplyMasterDataRsType.designationList : null;
        this.sharedData.setCompDesig({ comp: company, desg: designation });

      }
    }, err => {
      console.log('Service Error', err);
    });
  }
}
